import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/training-records/page';

export const Route = createFileRoute('/_app/settings/training-records/')({
  component: Page,
});
